import { motion, useReducedMotion } from "framer-motion";

// Fade + slide-up reveal on scroll into view. `delay` staggers grouped items.
export const Reveal = ({ children, delay = 0, className, y = 20, amount = 0.2, ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
